import { IApplicationState } from '../../types/redux';

export function getBuilderNewbuildings(state: IApplicationState) {
  return state.newbuilding.builderNewbuildings;
}

export function getNewbuildingsFromBuilderLink(state: IApplicationState) {
  return state.newbuilding.newbuildingsFromBuilderLink;
}

export function getSimilarNewbuildings(state: IApplicationState) {
  return state.newbuilding.similarNewbuildings;
}
